import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import ClearIcon from "@mui/icons-material/Clear";
import { createTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import AutocomplateCheckbox from "../dropdown/AutocomplateCheckbox";

export default function ModalCheckbox(props: any) {
  const [open, setOpen] = React.useState<boolean>(props.openModal);
  const [valueResponse, setValueResponse] = React.useState<any[]>([]);
  const [value, setValue] = useState<any[]>([]);

  React.useEffect(() => {
    setOpen(props.openModal);
  }, [props.openModal]);

  const handleClose = () => {
    setOpen(false);
    props.setOpenModal(false);
  };
  const handleOpen = () => setOpen(true);
  const queryClient = useQueryClient();

  const handelVerify = () => {
    props.setValue();
    handleClose();
  };
  const handelCancel = () => {
    handleClose();
  };
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });
  const theme = createTheme({
    direction: "rtl", // Both here and <body dir="rtl">
  });
  const changeValue = (e: any, value: any) => {
    setValue(e);
    setValueResponse(value);
  };

  const handleSubmit = () => {
    props.setChangeValue(valueResponse);
    props.setOpenModal(false);
  };
  const deactiveUserStyle = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    minWidth: {
      xs: 250,
      sm: 300,
      md: 400,
      lg: 500,
    },
    maxWidth: {
      xs: 250,
      sm: 300,
      md: 400,
      lg: 500,
    },

    maxHeight: "70vh",
    minHeight: "30vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    // overflow: "auto",
    // overflowX: "hidden",
    paddingRight: "3vh",
    paddingTop: "4vh",
    // direction: "ltr",
    borderRadius: "5px",
    "&::-webkit-scrollbar": {
      width: 7,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#F9FAFC",
      border: "2px solid #DAE0E4",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#9AAFC4",
    },
  };
  const removeTag = (tag: any) => {
    if (tag.childId) {
      setValueResponse(value.filter((node) => node.childId !== tag.childId));
      setValue(value.filter((item) => item.childId !== tag.childId));
    } else if (tag.parentId) {
      setValueResponse(value.filter((node) => node.parentId !== tag.parentId));
      setValue(value.filter((item) => item.parentId !== tag.parentId));
    } else if (tag.id) {
      setValueResponse(valueResponse.filter((node) => node.id !== tag.id));
      setValue(value.filter((item) => item !== tag.id));
    }
  };

  return (
    <div style={{ width: "100%", height: "100%", display: "flex" }}>
      <Modal
        open={props.openModal}
        onClose={() => {
          props.setOpenModal(false);
          setValue([]);
          setValueResponse([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"1.5rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                fontSize={"14px"}
                color={"#1D4A87"}
              >
                {props.title}
              </Typography>
            </Grid>

            <Grid item width={"100%"}>
              <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                  <div dir="rtl">
                    <AutocomplateCheckbox
                      id="addValue"
                      name="addValue"
                      value={value}
                      label={props.label}
                      options={props.allStoresAndBranches!}
                      onChange={changeValue}
                      changeMultiSelect={changeValue}
                      responseValue={valueResponse}
                    />
                  </div>
                </ThemeProvider>
              </CacheProvider>
            </Grid>
            {valueResponse.length > 0 && (
              <Box
                sx={{
                  borderTop: "1px solid #CCD1D6",
                  width: "100%",
                  paddingTop: "1rem",
                }}
              >
                <Typography
                  sx={{
                    color: "#1D4A87",
                    marginTop: "10px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                  }}
                >
                  {props.titleChip}
                </Typography>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    gap: "7px",
                    flexWrap: "wrap",
                    maxHeight: "10vh",
                    overflow: "auto",
                  }}
                >
                  {valueResponse.map((node: { title: string }) => (
                    <Box
                      sx={{
                        background: "#EDEFEF",
                        padding: "3px 7px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderRadius: "5px",
                        whiteSpace: "nowrap",
                      }}
                      key={node.title}
                    >
                      {node.title}
                      <Typography
                        sx={{ cursor: "pointer" }}
                        onClick={() => removeTag(node)}
                      >
                        <ClearIcon
                          sx={{ color: "#34495E", fontSize: "14px" }}
                        />
                      </Typography>
                    </Box>
                  ))}
                </Grid>
              </Box>
            )}
            <Grid item width={"100%"}>
              <Grid
                container
                flexDirection={"row"}
                justifyContent={"center"}
                spacing={1}
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Button
                    onClick={handleSubmit}
                    fullWidth
                    variant="contained"
                    disabled={valueResponse.length === 0}
                    className={
                      valueResponse.length === 0
                        ? "btnForm disabledBtn"
                        : "btnForm SuccessDefault"
                    }
                  >
                    ثبت
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  // maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      fontSize: "1rem",
                      color: "#fff",
                      height: "40px",
                      background: "#607D8B",
                    }}
                    onClick={() => {
                      props.setOpenModal(false);
                      setValue([]);
                      setValueResponse([]);
                    }}
                  >
                    بازگشت
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
